import { Controller } from '@hotwired/stimulus'
import { LocalStorageManager } from '../helpers/local_storage_manager'

// Connects to data-controller="table-resizer"
export default class extends Controller {
  static targets = ['table']

  declare readonly tableTarget: HTMLTableElement
  declare tableId: string
  declare localStorageManager: LocalStorageManager

  connect (): void {
    this.tableId = this.tableTarget.dataset.tableId ?? ''
    this.localStorageManager = new LocalStorageManager()
    this.addColumnIds()
    this.applyTableSettings()
    this.makeTableResizable()
  }

  makeTableResizable (): void {
    const columns = this.tableTarget.querySelectorAll('th')
    columns.forEach((column) => {
      const resizer = document.createElement('div')
      resizer.classList.add('resizableTable-resizer')
      resizer.style.height = `${this.tableTarget.offsetHeight}px`
      column.appendChild(resizer)
      this.makeColumnResizable(column, resizer)
    })
  }

  makeColumnResizable (column: HTMLElement, resizer: HTMLElement): void {
    const saveTableSettings = this.saveTableSettings.bind(this)

    const mouseDownHandler = (event: MouseEvent | TouchEvent): void => {
      x = (event instanceof MouseEvent) ? event.clientX : event.touches[0].clientX

      const columnStyles = window.getComputedStyle(column)

      originalWidth = parseInt(columnStyles.width)

      document.addEventListener('mousemove', mouseMoveHandler)
      document.addEventListener('mouseup', mouseUpHandler)
      document.addEventListener('touchmove', mouseMoveHandler)
      document.addEventListener('touchend', mouseUpHandler)

      resizer.classList.add('resizableTable-resizing')
      column.classList.add('pointerEvents-none')
    }

    const mouseMoveHandler = (e: MouseEvent | TouchEvent): void => {
      const dx = (e instanceof MouseEvent) ? e.clientX - x : e.touches[0].clientX - x
      column.style.width = `${originalWidth + dx}px`
      saveTableSettings()
    }

    const mouseUpHandler = (): void => {
      resizer.classList.remove('resizableTable-resizing')
      document.removeEventListener('mousemove', mouseMoveHandler)
      document.removeEventListener('mouseup', mouseUpHandler)
      document.removeEventListener('touchmove', mouseMoveHandler)
      document.removeEventListener('touchend', mouseUpHandler)
      column.classList.remove('pointerEvents-none')
    }

    let x = 0
    let originalWidth = 0

    resizer.addEventListener('mousedown', mouseDownHandler)
    resizer.addEventListener('touchstart', mouseDownHandler)
  }

  addColumnIds (): void {
    const columns = this.tableTarget.querySelectorAll('th')

    columns.forEach((column, index) => {
      column.setAttribute('data-columnid', index.toString())
    })
  }

  applyTableSettings (): void {
    if (this.tableId === '') return

    const columns = this.tableTarget.querySelectorAll('th')

    columns.forEach((column) => {
      const columnID = column.dataset.columnid
      if (columnID !== undefined) {
        const width = this.localStorageManager.getItem('ui_settings', 'tables', this.tableId, 'columns', columnID, 'width')
        if (typeof width === 'number') {
          column.style.width = `${width}px`
        }
      }
    })
  }

  saveTableSettings (): void {
    if (this.tableId === '') return

    const columns = this.tableTarget.querySelectorAll('th')

    columns.forEach((column) => {
      const columnID = column.dataset.columnid
      if (columnID !== undefined) {
        this.localStorageManager.setItem(column.offsetWidth, 'ui_settings', 'tables', this.tableId, 'columns', columnID, 'width')
      }
    })
  }
}
